const motorsportDataConverter = ({ selectedNews, newsList }) => {
  return {
    slideItems: (selectedNews || []).map((newsId) => {
      const news = newsList.find((news) => news.id === newsId);
      return {
        category: { text: news.category || "" },
        title: {
          text: news.title || "",
        },
        imageUrl: news.image || "",
      };
    }),
  };
};

const MOTORSPORT_DEFAULT_STYLE_SETTINGS = {};

export { motorsportDataConverter, MOTORSPORT_DEFAULT_STYLE_SETTINGS };
